module.exports = __webpack_public_path__ + "static/media/request_process_icon.bf1c4170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/request_process_icon.png
// module id = 831
// module chunks = 0